import React, { useEffect } from "react";
import useOutsideClick from "utilities/hooks/use-outside-click";
import { HighlightColor } from "utilities/enumerations/highlight-color";
import useToggleNotebookReferencePanel from "pages/notebooks/notebook-reference-panel/use-toggle-notebook-reference-panel";
import { NOTEBOOK_REF_PANEL_CLASS_NAME } from "pages/notebooks/notebook-reference-panel/notebook-reference-panel";
import CodeReferenceHighlightEditModalContents from "organisms/highlight-modal/code-reference-highlight-edit-modal-contents";
import { HighlightProperties } from "organisms/code-reference-block-editor/code-reference-preview";

const CSS_BASE_CLASS = "highlight-modal";

interface HighlightModalProps {
    onSave: (props: HighlightProperties) => void;
    onClose: () => void;
    onColorChange: (newColor: HighlightColor) => void;
}

const HighlightModal = (props: HighlightModalProps) => {
    const { onSave, onClose, onColorChange } = props;

    const modalRef = React.useRef<HTMLDivElement>(null);
    useOutsideClick(modalRef, onClose, "mousedown");
    const { showPanel: isRefPanelOpen } = useToggleNotebookReferencePanel();

    const adjustModalPosition = (
        element: HTMLDivElement,
        elementRectToAttachTo: DOMRect
    ) => {
        const rect = element.getBoundingClientRect();
        const leftThreshold = window.innerWidth - elementRectToAttachTo.width;
        const bottomThreshold = window.visualViewport?.height;
        const bottomOffset = "-230px";
        if (rect.right > leftThreshold) {
            element.style.right = "0px";
        }
        if (rect.bottom > bottomThreshold!) {
            element.style.top = bottomOffset;
        }
    };

    useEffect(() => {
        const notebooksReferencePanelRect = document
            .getElementsByClassName(NOTEBOOK_REF_PANEL_CLASS_NAME)
            .item(0)
            ?.getBoundingClientRect();
        if (modalRef.current && notebooksReferencePanelRect) {
            adjustModalPosition(modalRef.current, notebooksReferencePanelRect);
        }
    }, [isRefPanelOpen]);

    return (
        <div className={`${CSS_BASE_CLASS}`} ref={modalRef}>
            <CodeReferenceHighlightEditModalContents
                onClose={onClose}
                onSave={onSave}
                onColorChange={onColorChange}
            />
        </div>
    );
};

export default HighlightModal;
